import React from 'react';

import useWidgetRouterStore from './widgetRouterStore';
import { ActiveWidgetSlot } from './WidgetHost';

/**
 * ActiveWidgetOverlay — mounted at app root. Renders the active
 * spawn-on-demand widget regardless of which page is showing, so
 * `sdk.openWidget(...)` works from ManageVisitPage, the visit list,
 * banners, and any other surface that isn't inside a `<WidgetHost>`.
 *
 * The procedure widget is NOT rendered here — it's visit-scoped and
 * lives inside `WidgetHost` for the active consultation only.
 *
 * Since at most one top-level page is mounted at a time, the active
 * widget renders exactly once. WidgetHost takes precedence on the
 * consultation page (it has the visit context); other pages fall back
 * to this overlay.
 */
export default function ActiveWidgetOverlay() {
  const activeWidget = useWidgetRouterStore((s) => s.active);
  const closeWidget = useWidgetRouterStore((s) => s.closeWidget);

  if (!activeWidget) return null;

  return (
    <ActiveWidgetSlot
      kind={activeWidget.kind}
      context={activeWidget.context}
      opts={activeWidget.opts}
      visit={null}
      viewer={null}
      onClose={closeWidget}
    />
  );
}
